import { FC } from 'react';
import classNames from 'classnames';
import style from './StrainInfo.module.scss';
import { startCase } from 'lodash';
import { formatSpecialFlowerType } from 'utils/utils';

interface IStrainInfoProps {
  strain?: string;
  className?: string;
}

const StrainInfo: FC<IStrainInfoProps> = ({ strain, className }) => {
  if (!strain) return null;

  const formattedStrain = startCase(strain);

  return (
    <span
      aria-label={`Flower type: ${formattedStrain}`}
      className={classNames(
        style.flower__type,
        style.type__default,
        style[
          // eslint-disable-next-line max-len
          `type__${strain?.toLocaleLowerCase().replace(/\s+/g, '')}`
        ],
        className,
      )}
      role="group"
      title={formattedStrain}
    >
      <strong>{formatSpecialFlowerType(strain)}</strong>
    </span>
  );
};

export default StrainInfo;
